export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-vr-67a9ed2a923df2eccc57514ef95be694.jpg";